export const constants = {
  CVS_UPDATE_BY_ID: 'CVS_UPDATE_BY_ID',
  CVS_CONVERSATION_ADD: 'CVS_CONVERSATION_ADD',
  CVS_PREPEND_MESSAGE: 'CVS_PREPEND_MESSAGE',

  CVS_MSG_RETRIEVE_REQUEST: 'CVS_MSG_RETRIEVE_REQUEST',
  CVS_MSG_RETRIEVE_SUCCESS: 'CVS_MSG_RETRIEVE_SUCCESS',
  CVS_MSG_RETRIEVE_FAILURE: 'CVS_MSG_RETRIEVE_FAILURE',

  CVS_MSG_ADD: 'CVS_MSG_ADD',

  CVS_RETRIEVE_REQUEST: 'CVS_RETRIEVE_REQUEST',
  CVS_RETRIEVE_SUCCESS: 'CVS_RETRIEVE_SUCCESS',
  CVS_RETRIEVE_FAILURE: 'CVS_RETRIEVE_FAILURE',

  CVS_ALL_RETRIEVE_REQUEST: 'CVS_ALL_RETRIEVE_REQUEST',
  CVS_ALL_RETRIEVE_SUCCESS: 'CVS_ALL_RETRIEVE_SUCCESS',
  CVS_ALL_RETRIEVE_FAILURE: 'CVS_ALL_RETRIEVE_FAILURE',

  CVS_INIT: 'CVS_INIT',
  CVS_INIT_STATE: 'CVS_INIT_STATE'
}